import http from '../_http'

//partner_price api
const price = {
  //default
  listPrice: (m) => { return http.post(`manager/billing/price/list`, m); },
  detailPrice: (m) => { return http.get(`manager/billing/price/${m.id}`); },

  //crud
  insertPrice: (m) => { return http.post(`manager/billing/price`, m); },
  updatePrice: (m) => { return http.put(`manager/billing/price`, m); },
  deletePrice: (m) => { return http.delete(`manager/billing/price/${m.id}`); },
}

export default price

export { price }